export class JoinGameRequest {
    static Message = 'JoinGameRequest';

    public gameId: string;
    public playerName: string;

    constructor(gameId: string, playerName: string) {
        this.gameId = gameId;
        this.playerName = playerName;
    }
}

export class JoinGameResponse {
    static Message = 'JoinGameResponse';

    public gameId: string;
    public cursorImage: string;

    constructor(gameId: string, cursorImage: string) {
        this.gameId = gameId;
        this.cursorImage = cursorImage;
    }
}
